import { useUiTranslator } from "../../../hooks/useUiTranslator";
import { BaseModal } from "../BaseModal/BaseModal";

import { JSX } from "react";

import { Box, Button, CircularProgress, Typography } from "@mui/material";

interface IModalDialogConfirm {
  confirmLabel?: string;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  hasError?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  message: string;
  onCancel: () => void;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  msgError?: string;
}

export const ModalDialogConfirm = ({
  confirmLabel,
  startIcon,
  endIcon,
  hasError,
  isLoading,
  isOpen,
  message,
  onCancel,
  onClose,
  onConfirm,
  title,
  msgError,
}: IModalDialogConfirm): JSX.Element => {
  const t = useUiTranslator();
  return (
    <>
      <BaseModal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        isLoading={isLoading}
      >
        <Typography>{message}</Typography>
        {hasError ? (
          <Typography color="warning" variant="caption">
            {msgError}
          </Typography>
        ) : (
          <></>
        )}
        <Box display="flex" gap={2} mt={2}>
          <Button
            sx={{ flexGrow: 1 }}
            disabled={isLoading}
            onClick={onConfirm}
            variant="contained"
            color={hasError ? "error" : "primary"}
            endIcon={endIcon ? endIcon : undefined}
            startIcon={
              isLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : startIcon ? (
                startIcon
              ) : undefined
            }
          >
            {confirmLabel
              ? confirmLabel
              : t("CustomApp:buttons.confirm", "Confirm")}
          </Button>
          <Button
            sx={{ flexGrow: 1 }}
            disabled={isLoading}
            onClick={onCancel}
            variant="contained"
            color="secondary"
          >
            {t("CustomApp:buttons.cancel", "Cancel")}
          </Button>
        </Box>
      </BaseModal>
    </>
  );
};
